(function () {
  'use strict';

  function fmt(n) {
    return '$' + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  var CART_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" ' +
    'style="width:17px;height:17px" aria-hidden="true">' +
    '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
    '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>' +
    '</svg>';

  // ─── GPO Structure Renderer ───────────────────────────────────────────────
  // Polls after page load until GPO container is ready, then transforms GPO's
  // raw HTML into byld-pi visual structure (inputs/labels untouched).

  function renderGPOStructure() {
    var containers = document.querySelectorAll('#MainContent .gpo-container');
    if (containers.length === 0) return false;

    containers.forEach(function (container) {

      // ── 1. Switch: move helptext inline + wrap with price span ────────────
      container.querySelectorAll('[data-element-id*="switch"]').forEach(function (el) {
        if (el.dataset.byldProcessed) return;

        var helpTextEl  = el.querySelector('.gpo-helptext');
        var switchInput = el.querySelector('.gpo-switch [data-type="switch"]');
        if (!switchInput) return;

        // Parse helptext into byld-pi__addon-info (title + desc)
        if (helpTextEl) {
          var rawHtml   = helpTextEl.innerHTML;
          var parts     = rawHtml.split(/<br\s*\/?>/i);

          var titleText = parts[0] ? parts[0].replace(/(<([^>]+)>)/gi, '').trim() : '';
          var descText  = parts[1] ? parts[1].replace(/(<([^>]+)>)/gi, '').trim() : '';

          var addonInfo = document.createElement('div');
          addonInfo.className = 'byld-pi__addon-info';

          if (titleText) {
            var titleEl = document.createElement('div');
            titleEl.className = 'byld-pi__addon-title';
            titleEl.textContent = titleText;
            addonInfo.appendChild(titleEl);
          }

          if (descText) {
            var descEl = document.createElement('div');
            descEl.className = 'byld-pi__addon-desc';
            descEl.textContent = descText;
            addonInfo.appendChild(descEl);
          }

          // Insert addon-info before the gpo-switch's first child
          var gpoSwitchEl = switchInput.closest('.gpo-switch');
          gpoSwitchEl.insertBefore(addonInfo, gpoSwitchEl.firstChild);
          helpTextEl.remove();
        }

        // Wrap input + label in byld-price-wrapper with addon price span
        var addonPrice     = switchInput.getAttribute('data-addon-price') || '0';
        var priceFormatted = '+ $' + parseFloat(addonPrice).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        var gpoSwitch      = switchInput.closest('.gpo-switch');
        var gpoLabel       = gpoSwitch ? gpoSwitch.querySelector('label[for="' + switchInput.id + '"]') : null;

        if (gpoLabel) {
          var priceSpan = document.createElement('span');
          priceSpan.className = 'byld-pi__addon-price';
          priceSpan.style.display = 'inline-block';
          priceSpan.style.opacity = '0';
          priceSpan.textContent = priceFormatted;

          var priceWrapper = document.createElement('div');
          priceWrapper.className = 'byld-price-wrapper';

          gpoSwitch.insertBefore(priceWrapper, gpoLabel);
          priceWrapper.appendChild(priceSpan);
          priceWrapper.appendChild(switchInput);  // keep original input intact
          priceWrapper.appendChild(gpoLabel);     // keep original GPO label intact

          // Clear "Yes" text — price span replaces it visually
          var breakWord = gpoLabel.querySelector('.break-word');
          if (breakWord) breakWord.textContent = '';

          // Show price only when toggle is ON (opacity transition)
          switchInput.addEventListener('change', function () {
            priceSpan.style.opacity = this.checked ? '1' : '0';
          });
        }

        // ── Color swatch click → sync thumbnail + main image ────────────────
        var allSwatches = Array.from(container.querySelectorAll('.gpo-swatches.color-swatches input[type="radio"]'));
        allSwatches.forEach(function (swatchInput, idx) {
          swatchInput.addEventListener('change', function () {
            // wrap is in initSection scope — find it via data-section-id
            var piWrap = document.querySelector('.byld-pi[data-section-id]');
            if (!piWrap) return;
            var thumb = piWrap.querySelector('.byld-pi__thumb[data-idx="' + idx + '"]');
            if (!thumb) return;
            // Activate thumbnail
            piWrap.querySelectorAll('.byld-pi__thumb').forEach(function (t) {
              t.classList.remove('byld-pi__thumb--active');
            });
            thumb.classList.add('byld-pi__thumb--active');
            // Update main image
            var src = thumb.getAttribute('data-src');
            var mainImage = piWrap.querySelector('.byld-pi__main-wrap .byld-pi__main-img');
            if (mainImage && src) mainImage.src = src;
            // Sync dots
            piWrap.querySelectorAll('.byld-pi__dot').forEach(function (d, i) {
              d.classList.toggle('byld-pi__dot--active', i === idx);
            });
          });
        });

        el.dataset.byldProcessed = '1';
      });

      // ── 2. Vertical radio: inject helptext as byld-pi__radio-hdr ──────────
      container.querySelectorAll('[data-element-id*="radio"]').forEach(function (el) {
        if (el.dataset.byldProcessed) return;

        var helpTextEl  = el.querySelector('.gpo-helptext');
        var vertWrapper = el.querySelector('.gpo-ov-wrapper.vertical');
        if (!vertWrapper) return;

        if (helpTextEl) {
          var rawHtml   = helpTextEl.innerHTML;
          var parts     = rawHtml.split(/<br\s*\/?>/i);
          var titleText = parts[0] ? parts[0].replace(/(<([^>]+)>)/gi, '').trim() : '';
          var subText   = parts[1] ? parts[1].replace(/(<([^>]+)>)/gi, '').trim() : '';

          var hdr = document.createElement('div');
          hdr.className = 'byld-pi__radio-hdr';

          if (titleText) {
            var titleEl = document.createElement('div');
            titleEl.className = 'byld-pi__radio-title';
            titleEl.textContent = titleText;
            hdr.appendChild(titleEl);
          }

          if (subText) {
            var subEl = document.createElement('div');
            subEl.className = 'byld-pi__radio-sub';
            subEl.textContent = subText;
            hdr.appendChild(subEl);
          }

          vertWrapper.insertBefore(hdr, vertWrapper.firstChild);
          helpTextEl.remove();
        }

        el.dataset.byldProcessed = '1';
      });

    });

    return true;
  }

  // Poll every 500ms until GPO container appears, render once, then stop
  var gpoRenderDone     = false;
  var gpoRenderInterval = setInterval(function () {
    if (gpoRenderDone) return;
    var ready = renderGPOStructure();
    if (ready) {
      gpoRenderDone = true;
      clearInterval(gpoRenderInterval);
      // Initial summary render after GPO is ready
      document.querySelectorAll('.byld-pi[data-section-id]').forEach(function (wrap) {
        renderSummary(wrap.dataset.sectionId);
      });
    }
  }, 500);

  // ─── Summary Box Builder ──────────────────────────────────────────────────
  // Reads current GPO selections from DOM and builds byld-pi__sum-rows
  // dynamically inside .byld-pi__summary. Called on init + every GPO change.

  function renderSummary(sid) {
    var wrap          = document.querySelector('.byld-pi[data-section-id="' + sid + '"]');
    var rowsContainer = wrap ? wrap.querySelector('.byld-pi__sum-rows') : null;
    if (!rowsContainer) return;

    rowsContainer.innerHTML = '';

    var container = document.querySelector('#MainContent .gpo-container');
    if (!container) return;

    function toLabel(str) {
      return str.replace(/-/g, ' ').replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); });
    }

    container.querySelectorAll('.gpo-element.gpo-form__group').forEach(function (el) {

      // Color swatches
      var colorSwatch = el.querySelector('.gpo-swatches.color-swatches input[type="radio"]:checked');
      if (colorSwatch) {
        appendSummaryRow(rowsContainer, 'Color:', colorSwatch.value, '');
        return;
      }

      // Vertical radio (OS, GPU, CPU, PSU, Cooler)
      var vertWrapper = el.querySelector('.gpo-ov-wrapper.vertical');
      if (vertWrapper) {
        var checkedV = vertWrapper.querySelector('input[type="radio"]:checked');
        if (!checkedV) return;
        var keyV   = toLabel(checkedV.getAttribute('data-field-name') || checkedV.name);
        var priceV = checkedV.getAttribute('data-addon-price');
        appendSummaryRow(rowsContainer, keyV + ':', checkedV.value, priceV ? fmt(parseFloat(priceV)) : '');
        return;
      }

      // Horizontal radio (Memory, Storage)
      var horizWrapper = el.querySelector('.gpo-ov-wrapper.horizontal');
      if (horizWrapper) {
        var checkedH = horizWrapper.querySelector('input[type="radio"]:checked');
        if (!checkedH) return;
        var keyH   = toLabel(checkedH.getAttribute('data-field-name') || checkedH.name);
        var priceH = checkedH.getAttribute('data-addon-price');
        appendSummaryRow(rowsContainer, keyH + ':', checkedH.value, priceH ? fmt(parseFloat(priceH)) : '');
        return;
      }

      // Switch toggles (only when ON — show price only, no "Yes" text)
      var switchInp = el.querySelector('.gpo-switch [data-type="switch"]');
      if (switchInp && switchInp.checked) {
        var keyS   = toLabel(switchInp.getAttribute('data-field-name') || '');
        var priceS = switchInp.getAttribute('data-addon-price');
        appendSummaryRow(rowsContainer, keyS + ':', '', priceS ? fmt(parseFloat(priceS)) : '');
      }
    });
  }
  function buildSummaryRow(key, value, price) {
    var row = document.createElement('div');
    row.className = 'byld-pi__sum-row';

    var k = document.createElement('span');
    k.className   = 'byld-pi__sum-k';
    k.textContent = key;

    var v = document.createElement('span');
    v.className = 'byld-pi__sum-v';
    v.textContent = value;

    if (price) {
      var tag = document.createElement('span');
      tag.className   = 'byld-pi__sum-tag';
      tag.textContent = '+ ' + price;
      v.appendChild(document.createTextNode(' '));
      v.appendChild(tag);
    }

    row.appendChild(k);
    row.appendChild(v);
    return row;
  }

  function appendSummaryRow(container, key, value, price) {
    container.appendChild(buildSummaryRow(key, value, price));
  }

  // ─── Section init ─────────────────────────────────────────────────────────

  function initSection(wrap) {
    var sid          = wrap.dataset.sectionId;
    var basePrice    = parseFloat(wrap.dataset.basePrice)    || 0;
    var baseOriginal = parseFloat(wrap.dataset.baseOriginal) || basePrice + 50;
    var productTitle = wrap.dataset.productTitle             || '';

    var shopifyVariants = [];
    try {
      shopifyVariants = JSON.parse(wrap.dataset.variants || '[]');
    } catch (e) {
      shopifyVariants = [];
    }

    var state = {
      basePrice:    basePrice,
      baseOriginal: baseOriginal,
      model:        productTitle,
      color:        '',
      globoExtra:   0,
      variantOptions: {}
    };

    var mainImg = document.getElementById('byld-main-img-' + sid);

    // ─── Image helpers ────────────────────────────────────────────────────────

    function setMainImage(src, activeIdx) {
      if (!mainImg || !src) return;
      mainImg.src = src;
      if (typeof activeIdx === 'number') {
        syncDot(activeIdx);
        var thumb = wrap.querySelector('.byld-pi__thumb[data-idx="' + activeIdx + '"]');
        if (thumb) {
          wrap.querySelectorAll('.byld-pi__thumb')
              .forEach(function (t) { t.classList.remove('byld-pi__thumb--active'); });
          thumb.classList.add('byld-pi__thumb--active');
        }
        return;
      }
      var matched = wrap.querySelector('.byld-pi__thumb[data-src="' + src + '"]');
      if (matched) {
        wrap.querySelectorAll('.byld-pi__thumb')
            .forEach(function (t) { t.classList.remove('byld-pi__thumb--active'); });
        matched.classList.add('byld-pi__thumb--active');
        syncDot(parseInt(matched.dataset.idx, 10) || 0);
      }
    }

    function updateImageForVariant(variant) {
      if (!variant) return;
      if (variant.featured_image && variant.featured_image.src) {
        var rawSrc       = variant.featured_image.src;
        var optimisedSrc = rawSrc.replace(/(\.[^.?]+)(\?|$)/, '_1000x$1$2');
        var thumbIdx     = null;
        wrap.querySelectorAll('.byld-pi__thumb[data-src]').forEach(function (t) {
          var tBase = (t.dataset.src || '').split('?')[0].replace(/_\d+x(\d+x)?/, '');
          var vBase = rawSrc.split('?')[0].replace(/_\d+x(\d+x)?/, '');
          if (tBase === vBase) thumbIdx = parseInt(t.dataset.idx, 10);
        });
        setMainImage(optimisedSrc, thumbIdx !== null ? thumbIdx : undefined);
      }
    }

    // ─── Price display ────────────────────────────────────────────────────────

    function recalc() {
      var total = state.basePrice    + state.globoExtra;
      var orig  = state.baseOriginal + state.globoExtra;

      var hdrPrice = document.getElementById('byld-hdr-price-' + sid);
      var hdrOrig  = document.getElementById('byld-hdr-orig-'  + sid);
      if (hdrPrice) hdrPrice.textContent = fmt(total);
      if (hdrOrig)  hdrOrig.textContent  = fmt(orig);

      var tp = document.getElementById('byld-total-' + sid);
      var to = document.getElementById('byld-orig-'  + sid);
      if (tp) tp.textContent = fmt(total);
      if (to) to.textContent = fmt(orig);

      var sn = document.getElementById('byld-sum-name-' + sid);
      var sc = document.getElementById('byld-s-color-'  + sid);
      if (sn) sn.textContent = state.model;
      if (sc) sc.textContent = state.color;

      renderSummary(sid);
    }

    // ─── Globo integration ────────────────────────────────────────────────────

    function readGloboPriceFromDOM() {
      // Get addon total from GPO and copy directly to summary total price
      var moneyEl = document.querySelector('#MainContent .gpo-total .money');
      if (!moneyEl) return;

      var raw = moneyEl.textContent.replace(/[^0-9.]/g, '');
      var val = parseFloat(raw);

      // Update globoExtra for recalc
      if (!isNaN(val) && val !== state.globoExtra) {
        state.globoExtra = val;
      }

      // Directly write GPO total into summary price display
      var totalPriceEl = document.querySelector('.byld-pi__total-rhs .byld-pi__total-price');
      if (totalPriceEl && !isNaN(val)) {
        totalPriceEl.textContent = moneyEl.textContent.trim();
      }
    }

    document.addEventListener('globo:price:updated', function (e) {
      if (e.detail && typeof e.detail.price !== 'undefined') {
        state.globoExtra = (parseFloat(e.detail.price) || 0) / 100;
        recalc();
        renderSummary(sid);
      }
    });

    document.addEventListener('gpo:price:changed', function (e) {
      if (e.detail && typeof e.detail.extraPrice !== 'undefined') {
        state.globoExtra = (parseFloat(e.detail.extraPrice) || 0) / 100;
        recalc();
        renderSummary(sid);
      }
    });

    // Watch GPO container for DOM changes + use click delegation as fallback
    // GPO sets .checked property (not attribute), so we watch childList + click
    var summaryDebounce = null;

    function debouncedRenderSummary() {
      clearTimeout(summaryDebounce);
      summaryDebounce = setTimeout(function () {
        renderSummary(sid);
      }, 80);
    }

    var observerBusy = false;
    var globoObserver = new MutationObserver(function () {
      if (observerBusy) return;
      observerBusy = true;
      readGloboPriceFromDOM();
      debouncedRenderSummary();
      setTimeout(function () { observerBusy = false; }, 100);
    });
    globoObserver.observe(document.body, {
      childList: true,
      subtree:   true
    });

    // Click delegation on GPO container — catches radio + checkbox clicks
    // before GPO processes them, then re-reads after short delay
    document.addEventListener('click', function (e) {
      var inp = e.target;
      if (!inp) return;
      var inGPO = inp.closest('#MainContent .gpo-container');
      var isLabel = inp.tagName === 'LABEL' && inp.htmlFor && document.getElementById(inp.htmlFor);
      if (!inGPO && !(isLabel && document.getElementById(inp.htmlFor) && document.getElementById(inp.htmlFor).closest('#MainContent .gpo-container'))) return;
      debouncedRenderSummary();
    });

    // ─── Variant matching ─────────────────────────────────────────────────────

    function findMatchingVariant() {
      if (!shopifyVariants.length) return null;
      var selected = Object.values(state.variantOptions);
      if (!selected.length) return null;
      return shopifyVariants.find(function (v) {
        return selected.every(function (val) {
          return v.option1 === val || v.option2 === val || v.option3 === val;
        });
      }) || null;
    }

    function applyVariant(variant) {
      var inp = document.getElementById('byld-variant-id-' + sid);
      if (inp) inp.value = variant.id;

      var cartBtn = document.getElementById('byld-btn-cart-' + sid);
      var buyBtn  = document.getElementById('byld-btn-buy-'  + sid);
      if (cartBtn) cartBtn.dataset.variantId = variant.id;

      var available = !!variant.available;
      if (buyBtn)  buyBtn.disabled  = !available;
      if (cartBtn) cartBtn.disabled = !available;

      var stickyEl = document.querySelector('sticky-add-to-cart');
      if (stickyEl) {
        stickyEl.setAttribute('data-current-variant-id', variant.id);
        stickyEl.setAttribute('data-variant-available',  available);
      }

      if (variant.price) {
        state.basePrice    = variant.price / 100;
        state.baseOriginal = variant.compare_at_price
          ? variant.compare_at_price / 100
          : state.basePrice + 50;
      }

      updateImageForVariant(variant);
      recalc();
    }

    // ─── Model cards ──────────────────────────────────────────────────────────

    var currentPath = window.location.pathname;
    wrap.querySelectorAll('.byld-pi__model-card').forEach(function (card) {
      var slug     = card.dataset.slug || '';
      var slugPath = slug.replace(/^https?:\/\/[^/]+/, '');

      if (slugPath && currentPath === slugPath) {
        wrap.querySelectorAll('.byld-pi__model-card')
            .forEach(function (c) { c.classList.remove('byld-pi__model-card--sel'); });
        card.classList.add('byld-pi__model-card--sel');
      }

      card.addEventListener('click', function () {
        if (slug && slugPath !== currentPath) {
          window.location.href = slug;
          return;
        }
        wrap.querySelectorAll('.byld-pi__model-card')
            .forEach(function (c) { c.classList.remove('byld-pi__model-card--sel'); });
        card.classList.add('byld-pi__model-card--sel');
        state.model        = card.dataset.model || state.model;
        state.basePrice    = parseFloat(card.dataset.price) || basePrice;
        state.baseOriginal = state.basePrice + 50;
        recalc();
      });
    });

    // ─── Color / variant option cards ─────────────────────────────────────────

    wrap.querySelectorAll('[data-option-idx]').forEach(function (card) {
      card.addEventListener('click', function () {
        var optIdx  = card.dataset.optionIdx;
        var optName = card.dataset.optionName;
        var value   = card.dataset.value;

        wrap.querySelectorAll('[data-option-idx="' + optIdx + '"]')
            .forEach(function (c) {
              c.classList.remove('byld-pi__color-card--sel', 'byld-pi__opt-card--sel');
              c.setAttribute('aria-pressed', 'false');
            });

        card.classList.add(card.classList.contains('byld-pi__color-card')
          ? 'byld-pi__color-card--sel'
          : 'byld-pi__opt-card--sel');
        card.setAttribute('aria-pressed', 'true');

        state.variantOptions[optName] = value;

        if (card.dataset.hex) {
          state.color = value;
          var rgbStop = document.getElementById('byld-rgb-stop-' + sid);
          if (rgbStop) rgbStop.setAttribute('stop-color', card.dataset.hex);
        }

        var matched = findMatchingVariant();
        if (matched) applyVariant(matched);
        recalc();
      });
    });

    // ─── Thumbnail gallery ────────────────────────────────────────────────────

    wrap.querySelectorAll('.byld-pi__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        wrap.querySelectorAll('.byld-pi__thumb')
            .forEach(function (t) { t.classList.remove('byld-pi__thumb--active'); });
        thumb.classList.add('byld-pi__thumb--active');
        syncDot(parseInt(thumb.dataset.idx, 10) || 0);
        if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
      });
    });

    function syncDot(idx) {
      wrap.querySelectorAll('.byld-pi__dot').forEach(function (d, i) {
        d.classList.toggle('byld-pi__dot--active', i === idx);
      });
    }

    wrap.querySelectorAll('.byld-pi__dot').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.idx, 10) || 0;
        syncDot(idx);
        var thumb = wrap.querySelector('.byld-pi__thumb[data-idx="' + idx + '"]');
        if (thumb) thumb.click();
      });
    });

    // ─── Cart drawer refresh ──────────────────────────────────────────────────

    function refreshHorizonCart() {
      var cartRoot = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
      return fetch(cartRoot + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: { itemCount: cart.item_count, source: 'product-form-component' } }
          }));
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.open = true;
        });
    }

    // ─── Shared: collect Globo properties from form ───────────────────────────

    function collectPayload(varId, formId) {
      var productForm = formId ? document.getElementById(formId) : null;
      var payload = { id: parseInt(varId, 10), quantity: 1, properties: {} };

      var formData = productForm ? new FormData(productForm) : new FormData();
      if (!productForm) {
        formData.append('id', varId);
        formData.append('quantity', '1');
      }

      formData.forEach(function (value, key) {
        if (key === 'id' || key === 'quantity' || key === 'add') return;
        var propMatch = key.match(/^properties\[(.+)\]$/);
        if (propMatch) {
          payload.properties[propMatch[1]] = value;
        }
      });

      return payload;
    }

    // ─── Add to Cart ──────────────────────────────────────────────────────────

    var cartBtn = document.getElementById('byld-btn-cart-' + sid);
    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        var formId      = cartBtn.dataset.formId;
        var variantIdEl = document.getElementById('byld-variant-id-' + sid);
        var varId       = cartBtn.dataset.variantId || (variantIdEl && variantIdEl.value);
        if (!varId) return;

        cartBtn.disabled    = true;
        cartBtn.textContent = 'Adding…';

        var cartRoot = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
        var payload  = collectPayload(varId, formId);

        fetch(cartRoot + 'cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify(payload)
        })
          .then(function (res) {
            if (!res.ok) throw new Error();
            return res.json();
          })
          .then(function () { return refreshHorizonCart(); })
          .then(function () {
            cartBtn.textContent = 'Added ✓';
            setTimeout(function () {
              cartBtn.disabled  = false;
              cartBtn.innerHTML = 'Add To Cart ' + CART_ICON;
            }, 2200);
          })
          .catch(function () {
            cartBtn.disabled  = false;
            cartBtn.innerHTML = 'Add To Cart ' + CART_ICON;
          });
      });
    }

    // ─── Buy Now ──────────────────────────────────────────────────────────────

    var buyBtn = document.getElementById('byld-btn-buy-' + sid);
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var variantIdEl = document.getElementById('byld-variant-id-' + sid);
        var varId = variantIdEl && variantIdEl.value;
        if (!varId) return;

        var formId   = 'byld-product-form-' + sid;
        var cartRoot = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
        var payload  = collectPayload(varId, formId);

        buyBtn.disabled    = true;
        buyBtn.textContent = 'Redirecting…';

        fetch(cartRoot + 'cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify(payload)
        })
          .then(function (r) {
            if (!r.ok) throw new Error();
            return r.json();
          })
          .then(function () {
            window.location.href = cartRoot + 'checkout';
          })
          .catch(function () {
            var productForm = document.getElementById(formId);
            if (productForm) {
              productForm.submit();
            } else {
              window.location.href = cartRoot + 'checkout';
            }
            buyBtn.disabled    = false;
            buyBtn.textContent = 'Buy Now';
          });
      });
    }

    // ─── Modals ───────────────────────────────────────────────────────────────

    function openModal(modal)  { if (!modal) return; modal.style.display = 'flex'; document.body.style.overflow = 'hidden'; }
    function closeModal(modal) { if (!modal) return; modal.style.display = 'none';  document.body.style.overflow = ''; }

    function bindModal(trigger, modal) {
      if (!trigger || !modal) return;
      trigger.addEventListener('click', function () { openModal(modal); trigger.classList.add('active'); });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) { closeModal(modal); trigger.classList.remove('active'); }
      });
      var closeBtn = modal.querySelector('.byld-modal-close');
      if (closeBtn) closeBtn.addEventListener('click', function () { closeModal(modal); trigger.classList.remove('active'); });
    }

    bindModal(wrap.querySelector('.byld-pi__help-box'),        document.getElementById('byld-model-modal-'    + sid));
    bindModal(wrap.querySelector('.byld-pi__badge--promo'),    document.getElementById('byld-promo-modal-'    + sid));
    bindModal(wrap.querySelector('.byld-pi__badge--shipping'), document.getElementById('byld-shipping-modal-' + sid));

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      ['byld-model-modal-', 'byld-promo-modal-', 'byld-shipping-modal-'].forEach(function (prefix) {
        var m = document.getElementById(prefix + sid);
        if (m && m.style.display === 'flex') closeModal(m);
      });
    });

    // ─── Delivery date ────────────────────────────────────────────────────────

    var deliveryEl = document.getElementById('byld-delivery-date-' + sid);
    if (deliveryEl) {
      var d = new Date(); var count = 0;
      while (count < 10) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) count++;
      }
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      deliveryEl.textContent = months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    }

    // ─── Init ─────────────────────────────────────────────────────────────────

    var selectedColorCard = wrap.querySelector('[data-option-idx].byld-pi__opt-card--sel[data-hex]');
    if (selectedColorCard) {
      state.color = selectedColorCard.dataset.value || '';
      state.variantOptions[selectedColorCard.dataset.optionName] = selectedColorCard.dataset.value;
    }

    recalc();
  }

  function boot() {
    document.querySelectorAll('.byld-pi[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var wrap = e.target.querySelector('.byld-pi[data-section-id]');
    if (wrap) initSection(wrap);
  });

})();